<template>
	<div class="phproduct">
		<el-backtop ></el-backtop>
		<hpheader></hpheader>
		<div class="phpro-hea">{{procenter}}</div>
		<!-- <div class="prohea-nav">
			<div class="proheanav-cont">
				<div class="navcont-item">
					全部
				</div>
				<div class="navcont-item" v-for="l in 8">
					牙周治疗仪
				</div>
			</div>
		</div> -->
		<div class="product-cont">
			<div class="productcon-item" style="padding-top: .8rem" v-for="(item,index) in categorylistcontsecz" :id="item.id" :key="index">
				<div class="produccont-name" @click="proconblock(item.id)">
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phproductimg/phproduct1.png" v-show="item.mess1" />
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phproductimg/phproduct2.png" v-show="!item.mess1"/>
					{{item.name}}

				</div>
				<div class="productcon-prod">
					<!-- <div class="prod-img">
						<img @click="navtodetails()" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phproductimg/productbanimg.png" />
						<div class="proimg-ti">
							<div class="proimgit-title">这里的文案开发写的</div>
							<div class="proimgit-name">产品的名称文案型号</div>
							<div class="proimgit-title">产品的标题介绍文案</div>
							<div class="proimgit-but">了解更多</div>
						</div>
					</div> -->
					<div class="pro-moerepro" v-show="item.mess1">
						<div class="promore-item" v-for="(ite,inde) in lcategoryidlist" :key="inde" @click="detailto(ite.id)" v-if="ite.category_id==item.id">
							<div class="promore-img">
								<img :src="ite.rule_image" />
							</div>
							<div class="promore-name" :class="inde==0?'proimgit-title':''">{{ite.name}}</div>
							<div class="promore-title":class="inde==0?'proimgit-name':''">{{ite.name_content}}</div>
							<!-- <div class="proimgit-but" v-if="inde==0">了解更多</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<hpfooter ref="footer"></hpfooter>

	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	export default{
		data(){
			return{
				categorylistcontsecz:[],
				categorylist:[],
				lcategoryidlist:[],
				procenter:'产品中心',
			}
		},
		created() {
			window.scrollTo(0,0);
			this.pcchannelcategorylist()
			this.pcchannelcategoryidlist()
			this.pageParam()
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

				this.$router.push({path:'./pcproduct',query:{e:this.$route.query.e}})
				return
			}
			this.ress()

		},
		components:{
			hpfooter,
			hpheader
		},
		watch:{
			'$route': 'getParams'
		},
		methods:{
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.procenter = "产品中心"

				}else{
					this.procenter = "PRODUCTS"
				}
			},
			proconblock(e){
				/* console.log(e) */
				for(let i =0;i<this.categorylistcontsecz.length;i++){
					if(this.categorylistcontsecz[i].id==e){
						/* console.log(this.categorylistcontsecz[i]) */
						if(this.categorylistcontsecz[i].mess1==true){
							this.categorylistcontsecz[i].mess1=false
						}else{
							this.categorylistcontsecz[i].mess1=true
						}
					}
				}
				/* this.procont=e */
			},
			detailto(e){
				this.$router.push({path: '/phdetails',query:{e,type:'phone'}})
			},
			pcchannelcategoryidlist(){
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					page:1,
					pageSize:10000000,
					category_id:0,
					mold:"h5",
				}
				this.$api.get_channel_category_id_list(data).then((res) => {
					/* console.log('2222',res.data) */
					this.lcategoryidlist=res.data

					this.getParams()
				});
			},
			pcchannelcategorylist(){
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),

				}
				this.$api.get_channel_category_list(data).then((res) => {
					/* console.log('1111',res.data) */

					this.categorylist=res.data
					this.categorylistcontsecz=[];
					this.categorylist.map(((item, index)=> {
						this.categorylistcontsecz.push(Object.assign({},item,{mess1:true,mess2:7}))
					}))
					console.log('sfadfsf',this.categorylistcontsecz);
					//初始化结果,每一项加一个jsShow=true
				});
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
			getParams(){
				var selectId = this.$route.query.select
				this.$refs.footer.scrollIntoView(selectId)
			}
		}

	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phproduct{
		background: #FFF;
		padding-top: 0.88rem;
	}
	.phproduct-hea{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
	}
	.phproducthea-left{
		margin-left: 0.3rem;
		width: 0.97rem;
		height: 0.5rem;
	}
	.phproducthea-left img{
		width: 100%;
		height: 100%;
	}
	.phproducthea-right{
		margin-right: 0.3rem;
		width: 0.38rem;
		height: 0.38rem;
	}
	.phproducthea-right img{
		width: 100%;
		height: 100%;
	}
	.phpro-hea{
		font-size: 0.36rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 0.4rem;
		margin-bottom: 0.32rem;
	}
	.prohea-nav{
		margin-bottom: 0.32rem;
	}
	.proheanav-cont{
		display: flex;
		flex-wrap: nowrap;
		overflow: auto;
	}
	.navcont-item{
		min-width: 1.2rem;
		text-align: center;
		margin-right: 0.32rem;

	}
	.navcont-item:first-child{
		margin-right: 0rem;
		margin-left: -0.06rem;
	}
	.product-cont{
		margin-left: 0.3rem;
		margin-bottom: 0.6rem;
	}
	.produccont-name{
		display: flex;
		/* justify-content: center; */
		align-items: center;
		color: #D03E3D;
		margin-bottom: 0.24rem;
		font-size: 0.24rem;
		font-weight: 400;
		color: #D03E3D;
		letter-spacing: 0.01rem;
	}
	.produccont-name img{
		width: 0.24rem;
		height: 0.24rem;
		margin-left: 0.1rem;
	}
	.productcon-prod{

	}
	.prod-img{

	}
	.prod-img img{
		width: 6.9rem;
		height: 5.2rem;
		border-radius: 0.06rem;
	}
	.proimg-ti{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-top: 0.4rem;
	}
	.proimgit-title{
		font-size: 0.2rem;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
	}
	.proimgit-name{
		font-size: 0.44rem;
		font-weight: bold;
		color: #5d5f5f;
		letter-spacing: 0.02rem;
		margin-top: 0.24rem;
		margin-bottom: 0.24rem;
	}
	.proimgit-but{
		margin-top: 0.4rem;
		width: 1.5rem;
		height: 0.66rem;
		background: #E31E24;
		border-radius: 0.32rem;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
	}
	.pro-moerepro{
		display: flex;
		flex-wrap: wrap;
	}
	.promore-item{
		width: 3.3rem;
		margin-top: 0.4rem;
		margin-right: 0.3rem;
	}
	.promore-item .promore-img{
		width: 3.3rem;
		height: 3.3rem;
		border-radius: 0.06rem;
		overflow: hidden;
	}
	.promore-item .promore-img img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.promore-item:first-child{
		width: 6.9rem;
		margin-top: 0.4rem;
		margin-right: 0.3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.promore-item:first-child .promore-img{
		width: 6.9rem;
		height: 5.2rem;
		border-radius: 0.06rem;
		overflow: hidden;
	}
	.promore-title{
		font-size: 0.2rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-top: 0.2rem;
	}
	.promore-name{
		font-size: 0.28rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		margin-top: 0.12rem;
	}



	/* 底部样式 */

</style>
